import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogTitle,
} from '@ovComponents/2-component/dialog/dialog';
import { Button, Typography } from 'hephaestus/web';
import { useTranslation } from 'react-i18next';
import type { ReviewTradeRow } from '../../types/tradeReview.types';

export type ReviewTradeCancelDialogsProps = {
  confirmCancelSelected: boolean;
  confirmCancelAll: boolean;
  rowDialogOpen: boolean;
  confirmCancelRow: ReviewTradeRow | undefined;
  selectedCount: number;
  cancelAllCount: number;
  cancelAllFiltered: boolean;
  onCloseSelected: () => void;
  onCloseAll: () => void;
  onCloseRow: () => void;
  onConfirmSelected: () => void;
  onConfirmAll: () => void;
  onConfirmRow: () => void;
};

export const ReviewTradeCancelDialogs = ({
  confirmCancelSelected,
  confirmCancelAll,
  rowDialogOpen,
  confirmCancelRow,
  selectedCount,
  cancelAllCount,
  cancelAllFiltered,
  onCloseSelected,
  onCloseAll,
  onCloseRow,
  onConfirmSelected,
  onConfirmAll,
  onConfirmRow,
}: ReviewTradeCancelDialogsProps) => {
  const { t } = useTranslation(['bulkRebalance']);

  return (
    <>
      <Dialog open={confirmCancelSelected} onClose={onCloseSelected}>
        <DialogTitle>{t('reviewTrades.cancelSelectedTitle')}</DialogTitle>
        <DialogContent>
          <Typography variant='bodyMedium'>
            {t('reviewTrades.cancelSelectedBody', {
              count: selectedCount,
            })}
          </Typography>
        </DialogContent>
        <DialogFooter>
          <Button variant='text' onClick={onCloseSelected}>
            {t('reviewTrades.keepTrades')}
          </Button>
          <Button
            variant='contained'
            color='error'
            onClick={onConfirmSelected}
            data-testid='bulk-rebalance-review-cancel-selected-confirm'
          >
            {t('reviewTrades.cancelConfirm')}
          </Button>
        </DialogFooter>
      </Dialog>

      <Dialog open={rowDialogOpen} onClose={onCloseRow}>
        <DialogTitle>{t('reviewTrades.cancelRowTitle')}</DialogTitle>
        <DialogContent>
          <Typography variant='bodyMedium'>
            {t('reviewTrades.cancelRowBody', {
              ticker:
                confirmCancelRow?.financialProduct?.ticker ||
                t('reviewTrades.cancelRowFallback'),
            })}
          </Typography>
        </DialogContent>
        <DialogFooter>
          <Button variant='text' onClick={onCloseRow}>
            {t('reviewTrades.keepTrades')}
          </Button>
          <Button
            variant='contained'
            color='error'
            onClick={onConfirmRow}
            data-testid='bulk-rebalance-review-cancel-row-confirm'
          >
            {t('reviewTrades.cancelRowConfirm')}
          </Button>
        </DialogFooter>
      </Dialog>

      <Dialog open={confirmCancelAll} onClose={onCloseAll}>
        <DialogTitle>
          {t(
            cancelAllFiltered
              ? 'reviewTrades.cancelAllFilteredTitle'
              : 'reviewTrades.cancelAllTitle',
          )}
        </DialogTitle>
        <DialogContent>
          <Typography variant='bodyMedium'>
            {t(
              cancelAllFiltered
                ? 'reviewTrades.cancelAllFilteredBody'
                : 'reviewTrades.cancelAllBody',
              { count: cancelAllCount },
            )}
          </Typography>
        </DialogContent>
        <DialogFooter>
          <Button variant='text' onClick={onCloseAll}>
            {t('reviewTrades.keepTrades')}
          </Button>
          <Button
            variant='contained'
            color='error'
            onClick={onConfirmAll}
            data-testid='bulk-rebalance-review-cancel-all-confirm'
          >
            {t('reviewTrades.cancelAllConfirm')}
          </Button>
        </DialogFooter>
      </Dialog>
    </>
  );
};
